import { render } from "./DemandInput.vue?vue&type=template&id=b8bf086c"
import script from "./DemandInput.vue?vue&type=script&lang=ts"
export * from "./DemandInput.vue?vue&type=script&lang=ts"
script.render = render

export default script